import { updateUserCityCode, wx_get_jsapi_ticket } from "@/api/user"
import { router } from "@/router"
import store from "@/store"
import { get_location_href } from "@/util/LocationUtil"
import { Dialog, Toast } from "vant"
import { jsonp } from 'vue-jsonp'
import wx from "weixin-js-sdk"

import axios from "axios"

function wxConfig(res) {
    wx.error(err => {
        budo_log.info('#12 微信配置错误', err, res);
    })

    if (!res || !res.data) {
        budo_log.info("#16 wxConfig err", res)
        Toast("#16 wxConfig err no res");
        return
    }

    wx.config({
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp || res.data.timeStamp, // 必填，生成签名的时间戳
        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
        signature: res.data.sign, // 必填，签名
        jsApiList: ['getLocation', 'openLocation', 'chooseWXPay', 'scanQRCode'] // 必填，需要使用的JS接口列表
    });
}

export function wx_sdk_wx_pay(res, success, cancel) {
    budo_log.info("#20 wx_sdk_wx_pay", res)

    if (!/(micromessenger)/i.test(navigator.userAgent)) {
        alert("非微信环境, 不能微信支付");
        return;
    }

    wx.config({
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timeStamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.sign, // 必填，签名
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
    });

    budo_log.info("#30 chooseWXPay", res)

    wx.chooseWXPay({
        timestamp: res.data.timeStamp, // 支付签名时间戳
        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于32 位
        package: res.data.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
        signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: res.data.paySign, // 支付签名
        success: success,
        cancel: cancel
    })
}

export function wx_scan_qr(res, success, fail) {
    wxConfig(res);

    wx.ready(function () {
        wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: success,
            fail: fail
        })
    })
}

export function wx_open_location(res, args) {
    wxConfig(res)

    wx.ready(() => {
        var _lng = parseFloat(args.lng)
        var _lat = parseFloat(args.lat)
        budo_log.info("#81 wx_open_location", _lng, typeof _lng, _lat, typeof _lat, args)

        wx.openLocation({
            latitude: _lat, // 纬度 不能是字符串 否则 ios 不得行
            longitude: _lng, // 经度，浮点数，范围为180 ~ -180。
            name: args.name, // 位置名
            address: args.address, // 地址详情说明
            scale: 15, // 地图缩放级别,整型值,范围从1~28。默认为最大
            infoUrl: 'http://t.tt' // 在查看位置界面底部显示的超链接,可点击跳转
        })
    })
}

var user_location_insert = function (res) {
    axios.post("/v5/user-location-insert", {
        url: location.href,
        ...res
    });
}

export function getUserLocation(res, redirect) {
    wxConfig(res)

    wx.ready(function () {
        wx.getLocation({
            type: 'wgs84',
            success: function (res) {
                const lat = res.latitude;
                const lng = res.longitude;
                sessionStorage.setItem("USER_CURRENT_POI_LAT", lat);
                sessionStorage.setItem("USER_CURRENT_POI_LNG", lng);

                loadCity(lat, lng, redirect)

                user_location_insert(res)
            },

            cancel: function (res) {
                budo_log.info("#85 SET_CITY_NAME", res)

                store.commit('SET_CITY_CODE', '5101');
                store.commit('SET_CITY_NAME', '成都市');
                router.push({ path: redirect });
            },

            fail: function (res) {
                budo_log.info("#93 SET_CITY_NAME", res)

                store.commit('SET_CITY_CODE', '5101');
                store.commit('SET_CITY_NAME', '成都市');
                router.push({ path: redirect });
            }
        });
    })
}

export function closeWxWindows(res) {
    wx.config({
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp || res.data.timeStamp, // 必填，生成签名的时间戳
        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
        signature: res.data.sign, // 必填，签名
        jsApiList: ['closeWindow'] // 必填，需要使用的JS接口列表
    });

    wx.ready(function () {
        wx.closeWindow();
    })
}

export function get_user_poi_location_cached(res_1, callback, callback_2) {
    var cacheKey = "wx_get_location_cached"
    var expire = 60 * 1000

    var cache = sessionStorage.getItem(cacheKey)
    if (cache) {
        var res = JSON.parse(cache);

        if (res.createdAt > new Date().getTime() - expire) {
            budo_log.info("#147 get_user_poi_location_cached hit", res)
            callback()
            return // 缓存命中 直接返回
        } else {
            budo_log.info("#151 cache expire, now=", new Date().getTime(), "res=", res)
        }
    } else {
        budo_log.info("#154 no cache for " + cacheKey)
    }

    budo_log.info("#153 get_user_poi_location_cached miss, cache=", cache)
    get_user_poi_location(res_1, callback, callback_2)
}

export function wx_get_location_cached(callback, callback_2) {
    var cacheKey = "wx_get_location_cached"
    var expire = 60 * 1000

    var cache = sessionStorage.getItem(cacheKey)
    if (cache) {
        var res = JSON.parse(cache);

        if (res.createdAt > new Date().getTime() - expire) {
            budo_log.debug("#170 get_user_poi_location_cached hit", res)
            callback()
            return // 缓存命中 直接返回
        } else {
            budo_log.debug("#174 cache expire, now=", new Date().getTime(), "res=", res)
        }
    } else {
        budo_log.debug("#177 wx_get_location_cached no cache")
    }

    budo_log.debug("#180 get_user_poi_location_cached miss, cache=", cache)

    var href = get_location_href()

    wx_get_jsapi_ticket(encodeURIComponent(href)).then(res_1 => {
        get_user_poi_location(res_1, callback, callback_2)
    })
}

// TODO 极端情况下 如不回调 就未执行下一步
export function get_user_poi_location(res, callback, callback_2) {
    budo_log.debug("#127 get_user_poi_location", res)

    // 如果传入了失败回调 就可能进 如果没传 就一定会走第一个回调
    if ((!res || !res.data) && callback_2) {
        budo_log.info("#165 get_user_poi_location, callback_2", res)
        callback_2()
        return
    }

    wxConfig(res)

    return wx.ready(function () {
        return wx.getLocation({
            type: 'wgs84',
            success: function (res) {
                const lat = res.latitude
                const lng = res.longitude
                sessionStorage.setItem("USER_CURRENT_POI_LAT", lat)
                sessionStorage.setItem("USER_CURRENT_POI_LNG", lng)

                // 写缓存
                var cacheKey = "wx_get_location_cached"
                res.createdAt = new Date().getTime()

                budo_log.debug("#44 wx_getLocation ok", res)
                sessionStorage.setItem(cacheKey, JSON.stringify(res))

                budo_log.debug('#120 get_user_poi_location, 获取定位成功, 写入 sessionStorage', lat, lng)
                callback(true)
            },
            cancel: function (e) {
                budo_log.info('#233 get_user_poi_location, 定位取消', e)
                callback(false)
            },
            fail: function (e) {
                budo_log.info('#128 get_user_poi_location, 定位失败', e)
                callback(false)
            }
        })
    })
}

function loadCity(lat, lng, redirect) {
    jsonp(`https://apis.map.qq.com/ws/geocoder/v1/`,
        {
            output: 'jsonp',
            key: 'VGZBZ-MACHK-DTQJB-ACE53-W2BZE-CKF3T',
            location: `${lat},${lng}`
        }).then(res => {
            const city = res?.result?.ad_info?.city;
            const city_code = res?.result?.ad_info?.adcode;

            updateUserCityCode(city_code.substring(0, 4), city, `${lat},${lng}`).then(() => {
                store.commit('SET_CITY_CODE', city_code.substring(0, 4));
                store.commit('SET_CITY_NAME', city);
                router.push({ path: redirect });
            })
        })
}

// 微信登录
export function $wx_authorize_url(redirectUrl) {
    // login-success 后的回跳地址
    localStorage.setItem("budo.v2_redirect_url", redirectUrl);

    if (/(micromessenger)/i.test(navigator.userAgent)) {
        return "/v5/weixin-authorize?origin=" + location.origin;
    }

    // 非微信环境
    return "/v4/login";
}

export function $go_wx_auth_url(redirectUrl) {
    budo_log.debug("#160 $go_wx_auth_url, redirectUrl=" + redirectUrl);

    // sessionStorage 每次进窗口重新来
    var flag = sessionStorage.getItem("budo.confirm-go-login")
    if (flag && Date.now() - Number(flag) > 1000) { // 如果有这个标识 表示不是第一次 就确认一下
        Dialog.confirm({ message: "跳转去登录?" }).then(() => {
            location.href = $wx_authorize_url(redirectUrl)
        })
        return
    }

    Toast("正在去登录 ...");

    // 写一下标记 再来就不是首次了
    sessionStorage.setItem("budo.confirm-go-login", Date.now())

    // 没有标识 表示首次 直接跳
    location.href = $wx_authorize_url(redirectUrl)
}

// RC 客服地址
export function $wx_kefu_rc() {
    return "/v4/Kefu"
}

export function $kefu_img_url() {
    var host = location.host
    if (host.indexOf("v2.04mm.cn") > -1 || host.indexOf(".cdhuanying.com") > -1) {
        // HY的 
        return "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241113/3xgkphdsbdhk44dwkhtgzut7.jpg"
    }

    // RC的
    return "https://rc-admin-1259573531.cos.ap-chengdu.myqcloud.com/online-service.jpg"
}

// 关于我们 等 常量的 key
export function $sys_config_key_suffix() {
    var host = location.host
    if (host.indexOf("v2.04mm.cn") > -1 || host.indexOf(".cdhuanying.com") > -1) {
        // HY的
        return "_hy"
    }

    // RC的
    return ""
}